export default abstract class StaticWebClipboardHelper {
  static legacySetValue(value: string) {
    const textArea = document.createElement('textarea');
    textArea.value = value;

    // Avoid scrolling to bottom
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.position = 'fixed';

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      document.execCommand('copy');
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
    }

    document.body.removeChild(textArea);
  }

  static navigatorSetValue(value: string) {
    // noinspection JSIgnoredPromiseFromCall
    navigator.clipboard.writeText(value);
  }
}
